export const allowedExtByType = {
  PDF: ['.pdf'],
  Word: ['.doc', '.docx'],
  PPT: ['.ppt', '.pptx'],
  Excel: ['.xls', '.xlsx', '.csv'],
  HTML: ['.html', '.htm'],
  'Áudio': ['.mp3', '.wav', '.m4a', '.ogg'],
  'Vídeo': ['.mp4', '.webm', '.mov', '.m4v'],
  Link: [],
  Outro: [],
};

export function getAcceptForType(type) {
  const t = String(type || '');
  const exts = allowedExtByType[t] || [];
  return exts.length ? exts.join(',') : undefined;
}

export function validateFileForType(type, file) {
  if (!file) return { ok: true };
  const t = String(type || '');
  if (t === 'Link') return { ok: false, message: 'Itens do tipo Link não aceitam upload de arquivo.' };
  const allowed = allowedExtByType[t] || [];
  if (!allowed.length) return { ok: true };
  const name = String(file.name || '').toLowerCase();
  const ok = allowed.some((ext) => name.endsWith(ext));
  if (!ok) return { ok: false, message: `Formato não suportado para tipo ${t}. Permitidos: ${allowed.join(', ')}` };
  return { ok: true };
}
